// ListView.vue
<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useAdvances } from '@/composables/useAdvances'
import AdvanceForm from '@/components/AdvanceForm.vue'

export default defineComponent({
  setup() {
    // Call the composable to get items
    const { advances, fetchItems, advanceKeys } = useAdvances()

    // Fetch items when the component is mounted
    onMounted(() => {
      fetchItems()
    })

    // const advanceKeys = computed(() => {
    //   return advances.value.length > 0 ? Object.keys(advances.value[0]) : []
    // })

    // Expose to template and other options API hooks
    return {
      advances,
      advanceKeys
    }
  },

  components: {
    AdvanceForm
  }
})
</script>

<template>
  <h2>Advances</h2>
  <AdvanceForm
    :advanceIds="advances.map((advance) => advance.id).filter((id) => id !== undefined) as number[]"
  />
  <div>
    <table>
      <thead>
        <tr>
          <th v-for="key in advanceKeys" :key="key">{{ key }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in advances" :key="item.id">
          <td v-for="key in advanceKeys" :key="key">{{ item[key] }}</td>
        </tr>
        <tr v-if="advances.length === 0">
          <td :colspan="advanceKeys.length">No items found</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
